import React from 'react';
import { View, Text, TouchableOpacity, StyleSheet } from 'react-native';
import { CHAT_COLORS } from './chatStyles';
import { RESIDENTS_SVG_COMPONENTS } from '@/assets/residents';
import { SVG_COMPONENTS as ADMIN_SVG_COMPONENTS } from '@/assets/admin';
import { ReplyToInfo } from '@/types/residents/marketplaceListing';

const CloseIcon = ADMIN_SVG_COMPONENTS.X_CIRCLE;
const ReplyArrowIcon = RESIDENTS_SVG_COMPONENTS.REPLY_ARROW;

interface ReplyPreviewProps {
  replyTo: ReplyToInfo;
  onClear: () => void;
}

/**
 * Reply preview bar shown above the chat input when replying to a message
 */
export const ReplyPreview: React.FC<ReplyPreviewProps> = ({ replyTo, onClear }) => {
  // Truncate text if too long
  const truncatedText = replyTo.text.length > 100 
    ? `${replyTo.text.substring(0, 100)}...` 
    : replyTo.text;

  return (
    <View style={styles.container}>
      <View style={styles.iconContainer}>
        <ReplyArrowIcon width={16} height={16} color={CHAT_COLORS.accentBlueDark} />
      </View>
      <View style={styles.contentContainer}>
        <Text style={styles.senderName} numberOfLines={1}>
          Replying to {replyTo.senderName}
        </Text>
        <Text style={styles.messageText} numberOfLines={1}>
          {truncatedText || '(Image)'}
        </Text>
      </View>
      <TouchableOpacity
        style={styles.closeButton}
        onPress={onClear}
        hitSlop={{ top: 8, bottom: 8, left: 8, right: 8 }}
      >
        <CloseIcon width={16} height={16} color={CHAT_COLORS.textMuted} />
      </TouchableOpacity>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingHorizontal: 24,
    paddingVertical: 12,
    backgroundColor: CHAT_COLORS.messageBubbleReceived,
    borderLeftWidth: 3,
    borderLeftColor: CHAT_COLORS.accentBlueDark,
    marginHorizontal: 16,
    marginBottom: 8,
    borderRadius: 8,
    gap: 12,
  },
  iconContainer: {
    width: 24,
    height: 24,
    alignItems: 'center',
    justifyContent: 'center',
  },
  contentContainer: {
    flex: 1,
    gap: 2,
  },
  senderName: {
    fontSize: 12,
    fontWeight: '600',
    color: CHAT_COLORS.accentBlueDark,
    lineHeight: 16,
  },
  messageText: {
    fontSize: 13,
    fontWeight: '400',
    color: CHAT_COLORS.textSecondary,
    lineHeight: 18,
  },
  closeButton: {
    width: 24,
    height: 24,
    alignItems: 'center',
    justifyContent: 'center',
  },
});
